import { FC } from 'react';

import { Alert, Copy } from '@belong/ui-components';
import { applyDictionary } from '@belong/type-utils';

import { IUseAttachmentMessage, useAttachmentMessage } from '../../lib/useAttachmentMessage';
import { ChatMessageWrapper } from '../ChatMessage/ChatMessageWrapper';
import CONTENT from '../content.json';
import { AttachmentErrorWrapper, AttachmentLink } from './ChatAttachment.styles';

export const ChatMessageAttachment: FC<IUseAttachmentMessage> = props => {
  const { attachmentName, isRejected, shouldRender, url } = useAttachmentMessage(props);

  if (!shouldRender || !attachmentName) {
    return null;
  }

  if (isRejected) {
    return (
      <AttachmentErrorWrapper>
        <Alert position="INLINE" type="ERROR">
          <Copy>{applyDictionary({ filename: attachmentName }, CONTENT.attachmentMessage.error)}</Copy>
        </Alert>
      </AttachmentErrorWrapper>
    );
  }

  // This needs to happen after the `isRejected` because it will not be set when the `isRejected` is true
  if (!url) {
    return null;
  }

  return (
    <ChatMessageWrapper item={props.item}>
      <AttachmentLink href={url} target="_blank">
        {attachmentName}
      </AttachmentLink>
    </ChatMessageWrapper>
  );
};

ChatMessageAttachment.displayName = 'ChatMessageAttachment';
